import { GridItem, GridItemProps } from '@flos/react-ui';

// this mimics flos' "narrow" Grid variant
export const NarrowGridItem = ({ children }: GridItemProps) => {
    return (
        <GridItem colStart={3} span={8}>
            {children}
        </GridItem>
    );
};

export const WideGridItem = ({ children, colStart, span }: GridItemProps) => {
    return (
        <GridItem colStart={colStart ?? 1} span={span ?? 12}>
            {children}
        </GridItem>
    );
};
